import { BannerPositionSizeRaw } from '@/modules/main-frame/ads/game-ad-handler.types'

export type BannerPositionNormalized = {
    width: string
    height: string
    top: string
    left: string
}

function parsePct(value: string | undefined): number {
    return value ? parseFloat(value) || 0 : 0
}

export function normalizeBannerPosition(banner: BannerPositionSizeRaw): BannerPositionNormalized {
    const width = parsePct(banner.width)
    const height = parsePct(banner.height)
    const top = banner.top ? parsePct(banner.top) : 100 - parsePct(banner.bottom) - height
    const left = banner.left ? parsePct(banner.left) : 100 - parsePct(banner.right) - width
    return {
        width: banner.width,
        height: banner.height,
        top: `${top}%`,
        left: `${left}%`,
    }
}
